$(function () {

	// -----------------------------
	// HELPERS
	// -----------------------------

	function getTargetFromHash(hash) {

		if (!hash) return $();

		const id = hash.replace('#', '');
		if (!id) return $();

		// CSS.escape est top mais pas dispo partout (vieux navigateurs)
		if (window.CSS && CSS.escape) {
			return $('#' + CSS.escape(id));
		}

		// fallback simple (si jamais l'id contient des caractères spéciaux, ça peut casser)
		return $('#' + id);
	}


	// -----------------------------
	// ACCORDION
	// -----------------------------

	function openAccordionPanel($panel) {

		if (!$panel.length) return;

		const $acc = $panel.closest('.accordeon');
		const wasOpen = $panel.hasClass('open');

		if (wasOpen) return;

		const prevTop = $panel[0].getBoundingClientRect().top;

		$acc.find('.accordeon-panel').removeClass('open');
		$panel.addClass('open');

		const newTop = $panel[0].getBoundingClientRect().top;
		const delta  = newTop - prevTop;

		if (delta !== 0) {
			window.scrollBy(0, -delta);
		}

		const content = $panel.find('.ap-content')[0];

		if (content) {
			const onEnd = () => {
				$panel[0].scrollIntoView({
					block: 'start',
					behavior: 'smooth'
				});
				content.removeEventListener('transitionend', onEnd);
			};

			content.addEventListener('transitionend', onEnd, { once: true });
		}
	}

	// CLICK ACCORDION (repris de ton fichier) :contentReference[oaicite:2]{index=2}
	$('.ac-ctrl, .ap-title .title').on('click', function () {
		//openAccordionPanel($(this).closest('.accordeon-panel'));
		$(this).closest('.accordeon-panel').toggleClass("open");
	});


	// -----------------------------
	// TABS
	// -----------------------------

	function openTabForTarget($target) {

		if (!$target.length) return false;

		// Cherche le "container" de tabs. Ton code utilise .tab-parent :contentReference[oaicite:3]{index=3}
		
		const $panel = $target.closest('.tab-conent');
		if (!$panel.length) return false;

		
		//let $panel = $target;
		if (!$panel.attr('id')) return false;

		const panelId = $panel.attr('id');
		const selectorHref = '#' + panelId;
		

		const $tabParent = $panel.closest('.tab-parent');
		// Trouver le lien correspondant dans la nav
		const $link = $tabParent.find('.elements-tab-nav .tab-link[href="' + selectorHref + '"]');
		if (!$link.length) return false;

		// Rejoue la logique de ton tab.js :contentReference[oaicite:4]{index=4}
		$tabParent.find('.active').removeClass('active');
		$link.addClass('active');
		$tabParent.find(selectorHref).addClass('active');

		return true;
	}

	// CLICK TABS (repris de ton tab.js) :contentReference[oaicite:5]{index=5}
	$(document).on('click', ".elements-tab-nav .tab-link", function (e) {
		e.preventDefault();
		
		const $parent = $(this).closest(".tab-parent");
		$parent.find(".active").removeClass("active");
		$(this).addClass("active");
		$parent.find($(this).attr("href")).addClass("active");
	});


	// -----------------------------
	// HANDLE ANCHOR (ACCORDION + TAB)
	// -----------------------------

	function handleAnchor(hash) {
		
		const $target = getTargetFromHash(hash);
		if (!$target.length) return;

		// 1) Si cible dans accordéon => ouvrir panel
		const $accordionPanel = $target.closest('.accordeon-panel');
		if ($accordionPanel.length) {
			openAccordionPanel($accordionPanel);

			// petit délai pour laisser l'accordéon s'ouvrir (comme ton code) :contentReference[oaicite:6]{index=6}
			setTimeout(() => {
				$target[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
			}, 350);

			return;
		}

		// 2) Sinon, si cible dans tabs => ouvrir l’onglet
		const opened = openTabForTarget($target);
		if (opened) {
			// délai très court : le temps que les classes s'appliquent
			setTimeout(() => {
				$target[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
			}, 50);

			return;
		}

		// 3) Sinon scroll simple
		$target[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
	}


	// -----------------------------
	// PAGE LOAD
	// -----------------------------

	if (window.location.hash) {
		handleAnchor(window.location.hash);
	}


	// -----------------------------
	// CLICK SUR LIEN (#...) même page
	// -----------------------------

	$(document).on('click', 'a[href*="#"]', function () {
		
		if ( $(this).hasClass("tab-link") ){
			return;
		}
		
		const url = new URL(this.href);
		
		// même page uniquement (comme ton code) :contentReference[oaicite:7]{index=7}
		if (url.pathname !== window.location.pathname) return;
		
		handleAnchor(url.hash);
		
	});

});